var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('b-row',[(_vm.actions.length > 0)?_c('b-col',{staticClass:"mt-1",attrs:{"col":"","cols":"12"}},[_c('tabs',{attrs:{"tabs":_vm.actions}})],1):_c('b-col',[_c('empty-card',{attrs:{"type":"user.social"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }